import Dashboard from '../pages/Dashboard';
import ShoppingMalls from '../pages/ShoppingMalls';
import User from '../pages/user';
import EnterprisePage from '../pages/enterprise/index';
import NoticePage from '../pages/notice/index';
import EventPage from '../pages/event/index';
import BoardPage from '../pages/board/index';
import MerchantPage from '../pages/merchant/index';
import MerchantV2Page from '../pages/merchant-v2/index';
import NotificationPage from '../pages/notification/index';

export const protectedRoutes = [
  { path: '/', element: <Dashboard /> },
  { path: '/users', element: <User /> },
  { path: '/corporations', element: <EnterprisePage /> },
  { path: '/notices', element: <NoticePage /> },
  { path: '/events', element: <EventPage /> },
  { path: '/board', element: <BoardPage /> },
  { path: '/merchants', element: <MerchantPage /> },
  { path: '/merchants-v2', element: <MerchantV2Page /> },
  { path: '/shoppingmalls', element: <ShoppingMalls /> },
  { path: '/notifications', element: <NotificationPage /> },
]; 